import { useEffect, useState } from 'react';
import { useAffiliateId } from './hooks/useAffiliateId';
import { getFunnelById } from './api/payload';
import FunnelContent from './components/FunnelContent';

interface Funnel {
  affiliateLink: string;
  website?: { name?: string };
}

function App() {
  const affiliateId = useAffiliateId();
  const [funnel, setFunnel] = useState<Funnel | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!affiliateId) return;

    (async () => {
      try {
        const data = await getFunnelById(affiliateId);
        setFunnel(data);
      } catch (err) {
        setError('Funnel not found or invalid.');
      }
    })();
  }, [affiliateId]);

  // if (!affiliateId) return <p>Missing ?aff= parameter.</p>;
  if (error) return <p>{error}</p>;
  // if (!funnel) return <p>Loading funnel...</p>;

  return (
    <FunnelContent affiliateLink={funnel?.affiliateLink ?? 'https://www.digistore24.com/'} />
  );
}

export default App;
